import { Stepper, styled } from '@mui/material';

const StyledStepper = styled(Stepper)({});

export { StyledStepper };
